import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section id="hero" className="hero-section">
      <div className="container hero-container">
        <div className="hero-content">
          <p className="intro-text">Hello I'm Naor,</p>
          {/* <p className="title">A Developer with a unique background in Show Technology</p> */}
          <p className="intro-text">
           Passionate about developing creative ideas into real experiences using tech. 
          My work lives at the intersection of imagination and innovation.
          </p>
        </div>
        <div className="hero-image">
          <img src={require("../../assets/profile-image.jpg")} alt="Naor Bonomo" />
        </div>
      </div>
    </section>
  );
};

export default Hero; 